export default {"src":"/_next/static/media/swirl.efb721b6.svg","height":192,"width":360,"blurWidth":0,"blurHeight":0};